/**
 * Forms
 *
 * Adds a 'is-filled' class to fields that contain content or are currently focused.
 * Supported are input fields and textareas within a "js_focus-label" wrapper.
 *
 * Markup (simplified):
 *     <form class="c-form">
 *         <div class="c-form__item js_focus-label">
 *             <div class="c-form__field">
 *                 <label class="c-form__label" for="firstname">
 *                     First Name
 *                 </label>
 *                 <input type="text" id="firstname" class="form-control" name="" value="">
 *             </div>
 *         </div>
 *     </form>
 */
const initForm = () => {
    const fields = document.querySelectorAll('.js_focus-label input, .js_focus-label textarea');
    const focusClass = 'is-filled';

    let listener = {
        focus: function (ev) {
            return ev.target.parentNode.classList.add(focusClass);
        },
        blur: function (ev) {
            let field = ev.target;
            return '' === field.value.trim() ? field.parentNode.classList.remove(focusClass) : '';
        },
        change: function (ev) {
            return listener.focus(ev);
        }
    };

    function setEventListenersToFields() {
        fields.forEach((function (el) {
            let fieldValue = el.value;
            let parentEl = el.parentNode;

            // TODO: simplify/convert comma expression
            // eslint-disable-next-line max-len
            '' !== fieldValue.trim() && parentEl.classList.add(focusClass), ['focus', 'blur', 'change'].forEach((function (fieldValue) {
                return el.addEventListener(fieldValue, listener[fieldValue]);
            }));
        }));
    }

    setEventListenersToFields();
};

document.addEventListener('DOMContentLoaded', () => {
    initForm();
});
